/**
 * Error handling utilities for the application
 */

// Global error event listener to prevent the default error overlay
export const disableErrorOverlay = () => {
  if (typeof window !== 'undefined') {
    // Store original console error
    const originalConsoleError = console.error;
    
    // Override console.error to capture React refresh errors
    console.error = (...args) => {
      // Check if this is a React Fast Refresh error
      const isReactRefreshError = args.some(arg => 
        typeof arg === 'string' && 
        (arg.includes('React Fast Refresh') || 
         arg.includes('Aborted due to Fast Refresh'))
      );
      
      if (isReactRefreshError) {
        console.log('Fast Refresh error suppressed to prevent reload');
        return;
      }
      
      // Log all other errors normally
      originalConsoleError.apply(console, args);
    };
    
    // Prevent error propagation for webpack hot module replacement
    window.addEventListener('error', (event) => {
      if (event.error && event.error.message && 
          (event.error.message.includes('React Fast Refresh') || 
           event.error.message.includes('Aborted due to Fast Refresh'))) {
        event.preventDefault();
        console.log('Prevented auto-reload from Fast Refresh error');
      }
    });
    
    // Add a global error boundary to catch all unhandled errors
    window.addEventListener('unhandledrejection', (event) => {
      console.log('Unhandled Promise Rejection:', event.reason);
      // We could show a custom error UI here instead of letting Next.js handle it
    });
    
    console.log('Error overlay disabled, errors will be logged to console');
  }
};

// Function to log errors in development but not in production
export const logError = (error, componentName = 'Unknown') => {
  if (process.env.NODE_ENV !== 'production') {
    console.error(`Error in ${componentName}:`, error);
    
    // Log additional context if available
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
  }
  
  // You could also send errors to a monitoring service here
  // e.g., Sentry, LogRocket, etc.
};

// Helper to format error messages for display
export const formatErrorMessage = (error) => {
  if (!error) return 'An unknown error occurred';
  
  if (typeof error === 'string') return error;
  
  if (error.response && error.response.data && error.response.data.message) {
    return error.response.data.message;
  }
  
  return error.message || 'An unexpected error occurred';
}; 